import { MissionSchema } from "../schemas/mission.schema";

export const missionBackendErrorFieldMap: Record<
  string,
  keyof MissionSchema | "_base"
> = {
  display_name: "name",
  available_from: "start_date",
  available_until: "end_date",
  maximum_completions_per_user: "max_times",
  establishment_company_branch_id: "establishment",
  requirements: "conditions",
  requirements_attributes: "conditions",
  rewards: "rewards",
  rewards_attributes: "rewards",
  base: "_base",
};

export const missionErrorsTransformer = (
  errors: Record<string, string[]>,
) => {
  return Object.entries(errors).map(([key, value]) => {
    const normalizedKey = missionBackendErrorFieldMap[key] ?? key;
    if (normalizedKey === "_base") {
      const payload = Array.isArray(value) ? value : [String(value)];
      return { _base: payload };
    }

    const message = Array.isArray(value) ? value.join(", ") : String(value);
    return { [normalizedKey]: message };
  });
};
